import React from 'react';

const BlockedIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" transform="translate(2 2)">
      <circle cx="10" cy="10" r="11" fill="#2B73C7" stroke="#2B73C7" strokeWidth="2" />
      <path fillRule="nonzero" stroke="#FFF" strokeWidth="1.2" d="M10 0C4.475 0 0 4.475 0 10s4.475 10 10 10 10-4.475 10-10S15.525 0 10 0zm6.818 3.182L3.182 17.727" />
    </g>
  </svg>
);

export default BlockedIcon;
